import { createStyles, StyleRulesCallback, Theme } from "@material-ui/core/styles";

export const styles: StyleRulesCallback = ({ spacing }: Theme) =>
  createStyles({
    container: {
      marginBottom: spacing.unit * 10,
      marginTop: spacing.unit * 10
    },
    title: {
      marginBottom: spacing.unit * 2
    }
  });
